module.exports = __webpack_public_path__ + "img/PRL.c6f3000e.svg";